import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const InterestFact = ({ pathway }) => (
  <li className="ac-interest-fact" data-testid={`workshop-interest-${pathway || 'all'}`}>
    <Link to={`/academy/register-interest${pathway ? `?pathway=${pathway}` : ''}`} data-testid={`workshop-interest-link-${pathway || 'all'}`}>
      <strong>Register your interest <ArrowRight size={14} strokeWidth={2.4} aria-hidden="true" /></strong>
      <span>We&rsquo;ll let you know as soon as dates open</span>
    </Link>
  </li>
);

export const WorkshopFacts = ({ pathway }) => (
  <ul className="conv-facts" aria-label="Workshop format" data-testid={`workshop-facts-${pathway}`}>
    <li><strong>90-minute workshops</strong><span>Selective, on-site simulator sessions</span></li>
    <InterestFact pathway={pathway} />
  </ul>
);

export default WorkshopFacts;
